<template>
  <v-text-field color="primary" density="compact" variant="outlined" />
</template>

<script setup lang="ts">
defineOptions({
  name: 'SfTextField'
})
</script>
